export default __webpack_public_path__ + "3c2ee3d19077d2677703dc5c81b12c23.png";